// auth.js

export const getToken = () => {
    return localStorage.getItem('token');
  };
  